module.exports = __webpack_public_path__ + "img/yinsi_img2.1873407e.jpg";